var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{staticClass:"text-purple-ap-100 font-semibold leading-tight"},[_vm._v(" "+_vm._s(_vm.name)+" "),(_vm.isFavorite)?_c('i',{staticClass:"isFaved material-icons align-text-top text-3xl text-yellow-500"},[_vm._v("star")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }